/* eslint-disable  */
import React from 'react';
import { useState } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';

const EvalQuestionForm = props => {

    // Modal style
        const styles = {
            root: { 
                margin: '10px'
            }
        };

    // Data passed over 
        const {title, initialValues,setModalOpen} = props

    //Handle state for fields
        const [descriptor, setDescriptor] = useState(initialValues?.question_descriptor)
        const [descriptorText, setDescriptorText] = useState(initialValues?.question_text)

    // Handle state for modal 
        const [enabled, setEnabled] = useState(false)

    // Validate form to open
        const validateForm = () => {
            if (title ) {
                setEnabled(true)
            }
        }

    // handles to change the state of the form fields once it's clicked.
        const handleSubmit = async event => {
            // console.log(title)
            // console.log('eeeee')
            setModalOpen(false)
            event.preventDefault();
        }

        const handleChangeDescriptor = (e) => {
            setDescriptor(e.target.value)
            validateForm()
        }

        const handleChangeDescriptorText = (e) => {
            setDescriptorText(e.target.value)
            validateForm()
        }

    return (
        <form onSubmit={handleSubmit} style={styles.root}>
            <Grid container spacing={3} justifyContent='flex-end'>
                <TextField
                    name= 'title_name'
                    value={title.name || ''}
                    label= 'Selected Title'
                    fullWidth
                    disabled={true}
                >
                </TextField>
                <TextField
                    name='question_descriptor'
                    value={descriptor || ''}
                    label='Job Title Description'
                    fullWidth
                    onChange={handleChangeDescriptor}
                >
                </TextField>
                <TextField
                    name='descriptor_text'
                    value={descriptorText || ''}
                    label='Job Title Description'
                    fullWidth
                    multiline={true}
                    onChange={handleChangeDescriptorText}
                >
                </TextField>
            </Grid>

            <Grid container justifyContent='flex-end' spacing={3} style={{ marginTop: '10px' }}>
                <Grid item>
                    <Button
                        onClick={() => {
                            setModalOpen(false)
                        }}
                            children='Cancel'
                            variant='contained'
                            />
                </Grid>
                <Grid item>
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        disabled={!enabled}
                        onClick={ handleSubmit}
                        children='Submit'
                    />
                </Grid>
            </Grid>
        </form>

        );
};


const validate = values => {

    const errors = {
        question: {}
    };

    if (values.question && !values.question_descriptor) {
        errors.question_descriptor = 'You must enter a question descriptor';
    }

    if (values.question && !values.question_text) {
        errors.question_text = 'You must enter question text';
    }

    return errors;
};


export default EvalQuestionForm;
